export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
          投稿合作
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto">
          欢迎影视创作者、内容站点与我们建立合作。榴莲视频致力于打造开放的高清影视聚合生态，期待与苹果视频、91视频网站、豆花视频、菠萝视频、红杏视频、青青草视频等更多优质平台携手，共同为用户提供丰富的视频播放资源。
        </p>
        <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 rounded-xl bg-background-100 border border-background-200/70">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
            <i className="ri-mail-send-line text-2xl text-accent-600"></i>
          </div>
          <div className="text-left">
            <p className="text-foreground-800 font-medium text-sm">商务合作 / 内容投稿</p>
            <p className="text-foreground-500 text-xs mt-1">请发送邮件至合作邮箱，我们将在24小时内回复</p>
          </div>
          <span className="px-5 py-2 rounded-full bg-accent-100 text-accent-700 text-sm font-medium whitespace-nowrap">
            contact@示例域名.com
          </span>
        </div>
      </div>
    </section>
  );
}